module.exports = __webpack_public_path__ + "img/profile-avatar.bad2152f.png";